import { z } from 'zod'

/** Locale used to identify the language. */
export const Locale = z.enum(['en-GB', 'es-ES', 'fr-FR'])
export type Locale = z.infer<typeof Locale>
